import {Injectable} from '@angular/core';
import {UtilService} from './util.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Article} from '../model/Article';
import {Amount} from '../model/Amount';
import {CartBuyRequest} from '../model/CartBuyRequest';
import {CartItem} from '../model/CartItem';

@Injectable()
export class AdditionalPurchaseService {

  constructor(private http: HttpClient, private utilService: UtilService) {
  }

  getArticles(storeTerminalId: number): Observable<Article[]> {
    const url = this.utilService.getApiUrl('price-lists/items?terminalId=' + storeTerminalId);
    return this.http.get(url)
      .map(
        (response: any) => {
          if (response.status === 0) {
            return response.data.map(value => new Article(value));
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        }
      );
  }

  getShoppingCartContent(): Observable<Article[]> {
    const url = this.utilService.getApiUrl('price-lists/cart');
    return this.http.get(url)
      .map(
        (response: any) => {
          if (response.status === 0) {
            return response.data.map(value => new Article(value));
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        }
      );
  }

  addItemToShoppingCart(priceListItemId: number, quantity: number): Observable<any[]> {
    const url = this.utilService.getApiUrl('price-lists/cart/add');
    const body = {
      id: priceListItemId,
      quantity: quantity
    };

    return this.http.post(url, body)
      .map(
        (response: any) => {
          if (response.status === 0) {
            return response.data.items;
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        }
      );
  }

  addCustomItemToShoppingCart(item: CartItem): Observable<any[]> {
    const url = this.utilService.getApiUrl('price-lists/cart/add/custom');

    return this.http.post(url, item)
      .map(
        (response: any) => {
          if (response.status === 0) {
            return response.data.items;
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        }
      );
  }

  deleteItem(articleId: number, quantity: number): Observable<any[]> {
    const url = this.utilService.getApiUrl('price-lists/cart/' + articleId + '/' + quantity);
    return this.http.delete(url)
      .map(
        (response: any) => {
          if (response.status === 0) {
            return response.data.items;
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        }
      );
  }

  emptyShoppingCart(): Observable<Article[]> {
    const url = this.utilService.getApiUrl('price-lists/cart');
    return this.http.delete(url)
      .map(
        (response: any) => {
          if (response.status === 0) {
            return response.data;
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        }
      );
  }

  buyCartContent(storeTerminalId: number, req: CartBuyRequest): Observable<any> {
    const url = this.utilService.getApiUrl('price-lists/cart/buy?terminalId=' + storeTerminalId);
    return this.http.post(url, req)
      .map(
        (response: any) => {
          if (response.status === 0) {
            return response.data;
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        }
      );
  }

  buyCartContentWithoutInvoice(storeTerminalId: number): Observable<any> {
    const url = this.utilService.getApiUrl('price-lists/cart/no_invoice_buy?terminalId=' + storeTerminalId);

    return this.http.post(url, {})
      .map(
        (response: any) => {
          if (response.status === 0) {
            return response.data;
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        }
      );
  }

  getTotalPrice(): Observable<Amount> {
    const url = this.utilService.getApiUrl('price-lists/cart/total');
    return this.http.get(url)
      .map(
        (response: any) => {
          if (response.status === 0) {
            return new Amount(response.data);
          } else {
            throw Observable.throw(response);
          }
        },
        (error: any) => {
          return error;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/additional-purchase.service.ts